<template>
  <div>
    <div class="container-fluid mt-3 homepage" v-if="role=='Super Admin' || role=='admin'">
      <!--quick information-->
      <!-- <div class="row">
        <div class="col-xl-3 col-md-6">
          <div class="card card-stats mb-2" show-footer-line="true">
            <div class="card-body py-2">
              <div class="row">
                 <div class="col pl-2">
                    <h5 class="card-title text-uppercase text-muted mb-0">Total Students</h5>
                    <span class="h2 font-weight-bold mb-0">1500</span>
                 </div>
                 <div class="col-auto pl-0 pr-2">
                    <div class="icon icon-shape text-white rounded-circle shadow bg-gradient-red"><i class="fas fa-users"></i></div>
                 </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <div class="card card-stats mb-2" show-footer-line="true">
            <div class="card-body py-2">
              <div class="row">
                 <div class="col pl-2">
                    <h5 class="card-title text-uppercase text-muted mb-0">Teachers</h5>
                    <span class="h2 font-weight-bold mb-0">20</span>
                 </div>
                 <div class="col-auto pl-0 pr-2">
                    <div class="icon icon-shape text-white rounded-circle shadow bg-gradient-info"><i class="fas fa-chalkboard-teacher"></i></div>
                 </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xl-3 col-md-6">
          <div class="card card-stats mb-2" show-footer-line="true">
            <div class="card-body py-2">
              <div class="row">
                 <div class="col pl-2">
                    <h5 class="card-title text-uppercase text-muted mb-0">Total Classes</h5>
                    <span class="h2 font-weight-bold mb-0">15</span>
                 </div>
                 <div class="col-auto pl-0 pr-2">
                    <div class="icon icon-shape text-white rounded-circle shadow bg-gradient-green"><i class="fas fa-check"></i></div>
                 </div>
              </div>
            </div>
          </div>

        </div>
        <div class="col-xl-3 col-md-6">
          <div class="card card-stats mb-2" show-footer-line="true">
            <div class="card-body py-2">
              <div class="row">
                 <div class="col pl-2">
                    <h5 class="card-title text-uppercase text-muted mb-0">Preparing ORDERS</h5>
                    <span class="h2 font-weight-bold mb-0">{{preparingorder.count}}</span>
                 </div>
                 <div class="col-auto pl-0 pr-2">
                    <div class="icon icon-shape text-white rounded-circle shadow bg-gradient-orange"><i class="fas fa-fire"></i></div>
                 </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="row mb-5">
        <div class="col">
          <div class="card shadow" :class="''">
            <div class="card-header border-0" :class="''">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0" :class="''">
                    Student list
                  </h3>
                </div>
                <div class="col text-right">
                  <base-input class="mb-0 search-input mr-2" input-group-classes="input-group-merge" placeholder="Search User" v-model="search_term" @keyup.enter="searchuser()">
                      <template slot="append"><a><i class="fas fa-search" @click="searchuser()"></i></a></template>
                  </base-input>
                  <base-button type="primary" @click="cleardata()">Clear</base-button>
                  <base-button type="primary" @click="addstudentpop()">Add student</base-button>
                 <!--  <base-input class="mb-0 search-input mr-2" input-group-classes="input-group-merge" placeholder="Search order" v-model="search_term"  @keyup.enter="searchOrder()">
                      <template slot="append"><a href="#"><i class="fas fa-search" @click="searchOrder()"></i></a></template>
                  </base-input>
                  <select class="form-control d-inline w-auto mr-2" v-model="status" @change="getorderbystatus()">
                    <option value="">Status</option>
                    <option value="pending">Pending</option>
                    <option value="confirm">Confirmed</option>
                    <option value="preparing">Preparing</option>
                    <option value="ready">Ready</option>
                    <option value="dispatched">Dispatched</option>
                    <option value="delivered">Completed</option>
                    <option value="cancelled">Cancelled</option>
                    <option value="returned">Returned</option>
                  </select>
                  <base-button type="primary" @click="cleardata()">Clear</base-button> -->
                </div>
              </div>
            </div>
            <div class="table-responsive" style="display: block;">
              <base-table class="table align-items-center table-flush" :class="''" :thead-classes="'thead-light'" tbody-classes="list" :data="userData">
                <template slot="columns"> 
                  <th>S. No.</th>
                  <th>User</th>
                  <th>Class</th>
                  <th>Section</th>
                  <th>Admission No</th>
                  <th>Phone</th>
                  <th>Email</th>
                  <th>Type</th>
                  <th>Actions</th>
                </template>
                <template slot-scope="{row,index}">
                    <td class="budget">
                      <p class="mb-0">{{ (offset*30)+(index+1) }}</p>
                    </td>
                    <td class="budget" >
                      <p class="mb-0">{{row.user_name}}</p>
                    </td>
                    <td class="budget" >
                      <p class="mb-0" v-if="row.user_class">{{row.user_class.class_name}}</p>
                    </td>
                    <td class="budget" >
                      <p class="mb-0" v-if="row.user_section">{{row.user_section.section_name}}</p>
                    </td>
                    <td class="budget" >
                      <p class="mb-0">{{row.admission_no}}</p>
                    </td>
                    <td class="budget">
                      <p class="mb-0"><a :href="'tel:+91'+row.user_phone" class="link-text">{{row.user_phone}}</a></p>
                    </td>
                    <td class="budget">
                      <p class="mb-0"><a :href="'mailto:'+row.user_email" target="_blank" class="link-text">{{row.user_email}}</a></p>
                    </td>
                    <td class="budget">
                      <span v-if="row.user_type=='guestlogin'" class="badge badge-dot badge-success">
                        <i class="bg-success"></i>
                        <span class="status">Guest</span>
                      </span>
                      <span v-if="row.user_type=='login'" class="badge badge-dot badge-primary">
                        <i class="bg-primary"></i>
                        <span class="status">Regular</span>
                      </span>
                    </td>
                    <td class="text-right">
                      <base-dropdown menuOnRight>
                        <base-button slot="title-container" size="sm" type="white" class="shadow-none">
                          <i class="fas fa-ellipsis-v"></i>
                        </base-button>
                            <router-link :to="'/students/viewstudent/'+row._id" class="dropdown-item">Student Details</router-link>
                            <!-- <a :href="'/users/viewuser/'+row._id" class="dropdown-item">View</a> -->
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item"  @click="openuser(row)">Edit</a>
                            <a class="dropdown-item"  @click="deletestudent(row)">Delete</a>
                      </base-dropdown>
                    </td>
                </template>
              </base-table>
              <!-- <div class="d-block mb-5 mt-2">
                <base-button
                  type="success"
                  class="float-center m-auto d-block"
                   v-if="loadmorefound" 
                   @click="loadmore()"
                >
                  <span>Load More</span>
                </base-button>
              </div> -->
              <!-- no result found -->
              <div class="card-footer justify-content-center" id="noresult" v-if="datanotfound">
                <div class="col-md-3 mx-auto mt-4 text-center">
                    <img src="/img/theme/no-result.png" class="img-fluid">
                    <p class="mt-4">No Student found.</p>
                    <base-button type="primary" @click="cleardata()" outline>Fetch all</base-button>
                </div>
              </div>
              <!-- shimmer starts here -->
              <div class="col-md-12" v-if="userData.length==0 && !datanotfound">
                <div class="row justify-content-center">
                  <div class="col-lg-12 mt-3">
                      <div class="card border-0 shadow">
                         <div class="card-body pt-2 pb-1">
                              <div class="row">
                                  <div class="col-md-3 col-3 mt-1 mb-1">
                                      <span class="circle-shimmer shine"></span>
                                  </div>
                                  <div class="col-md-9 col-9 mt-1 mb-1">
                                      <div class="div-shimmer w-100 mt-0 pr-4">
                                        <span class="line-shimmer w-100 shine"></span>
                                        <span class="line-shimmer w-100 shine"></span>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="col-lg-12">
                      <div class="card border-0 shadow">
                         <div class="card-body pt-2 pb-1">
                              <div class="row">
                                  <div class="col-md-3 col-3 mt-1 mb-1">
                                      <span class="circle-shimmer shine"></span>
                                  </div>
                                  <div class="col-md-9 col-9 mt-1 mb-1">
                                      <div class="div-shimmer w-100 mt-0 pr-4">
                                        <span class="line-shimmer w-100 shine"></span>
                                        <span class="line-shimmer w-100 shine"></span>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="col-lg-12">
                      <div class="card border-0 shadow">
                         <div class="card-body pt-2 pb-1">
                              <div class="row">
                                  <div class="col-md-3 col-3 mt-1 mb-1">
                                      <span class="circle-shimmer shine"></span>
                                  </div>
                                  <div class="col-md-9 col-9 mt-1 mb-1">
                                      <div class="div-shimmer w-100 mt-0 pr-4">
                                        <span class="line-shimmer w-100 shine"></span>
                                        <span class="line-shimmer w-100 shine"></span>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="col-lg-12">
                      <div class="card border-0 shadow">
                         <div class="card-body pt-2 pb-1">
                              <div class="row">
                                  <div class="col-md-3 col-3 mt-1 mb-1">
                                      <span class="circle-shimmer shine"></span>
                                  </div>
                                  <div class="col-md-9 col-9 mt-1 mb-1">
                                      <div class="div-shimmer w-100 mt-0 pr-4">
                                        <span class="line-shimmer w-100 shine"></span>
                                        <span class="line-shimmer w-100 shine"></span>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                </div>
              </div>
              <!-- shimmer ends here -->
            </div>
            <div class="card-footer d-flex justify-content-end" v-if="!datanotfound">
                <nav aria-label="Page navigation example">
                  <ul class="pagination">
                    <!-- <li class="page-item d-flex mr-2">
                      <p class="mb-0 px-1 mt-1">
                        Page
                      </p>
                      <input
                        id="page_no"
                        size="4"
                        class="mx-1 p-1 text-center"
                        style="border: 1px solid #e9ecff;border-radius: 5px !important;background-color: #e9ecff;width: 4em;"
                        type="number"
                        name="page_no"
                      >
                      <base-button
                        block
                        type="primary"
                        class="px-3 mx-1"
                        title="GO"
                        size="sm"
                        @click="gotopage()"
                      >
                        GO
                      </base-button>
                    </li> -->
                    <li class="page-item">
                      <a
                        class="page-link"
                        @click="previouspage()"
                      > <span aria-hidden="true"><i
                        aria-hidden="true"
                        class="fa fa-angle-left"
                      /></span> </a>
                    </li>
                    <li class="page-item">
                      <a
                        class="page-link"
                        @click="nextpage()"
                      > <span aria-hidden="true"><i
                        aria-hidden="true"
                        class="fa fa-angle-right"
                      /></span> </a>
                    </li>
                  </ul>
                </nav> 
              </div>
          </div>
        </div>
      </div>
      <modal :show.sync="addstudent">
      <p
        id="modal-title-default"
        slot="header"
        class="modal-title"
      >
        <span>Add student</span>
      </p>
      <template>
        <form @submit.prevent>
          <div class="row">
            <div class="col-lg-12">
                <base-input label="User Name" placeholder="User Name" v-model="model.user_name" input-classes="" />
                <div
                  v-if="$v.model.user_name.$error"
                  class="error h5 text-danger mt--4 pl-1"
                >
                  Field is required.
              </div>
            </div>
            <div class="col-lg-12">
                <base-input label="Admission number" placeholder="Admission number" v-model="model.admission_no" input-classes="" />
                  <div
                  v-if="$v.model.admission_no.$error"
                  class="error h5 text-danger mt--4 pl-1">
                  Field is required.
                 </div>
            </div>
            <div class="col-lg-12">
                <base-input label="User Email" placeholder="User Email" v-model="model.user_email" input-classes="" />
                <div
                  v-if="$v.model.user_email.$error"
                  class="error h5 text-danger mt--4 pl-1"
                >
                  Field is required.
                </div>
            </div>
            <div class="col-lg-12">
                <base-input label="User Phone" placeholder="User Phone" v-model="model.user_phone" input-classes="" />
                <div
                  v-if="$v.model.user_phone.$error"
                  class="error h5 text-danger mt--4 pl-1"
                >
                  Field is required.
                </div>
            </div>
            <div class="col-lg-12">
                <base-input type="date" label="DOB" placeholder="DOB" v-model="model.user_dob" input-classes="" />
                <div
                  v-if="$v.model.user_dob.$error"
                  class="error h5 text-danger mt--4 pl-1"
                >
                  Field is required.
                </div>
            </div>
            <div class="col-lg-12">
                <base-input label="Father's Name" placeholder="Father's Name" v-model="model.father_name" input-classes="" />
            </div>
            <div class="col-lg-12">
                <base-input label="Mother's Name" placeholder="Mother's Name" v-model="model.mother_name" input-classes="" />
            </div>
            <div class="col-lg-12">
              <label class="form-control-label">Profile Picture</label>
              <input
                  id="file"
                  ref="myFiles"
                  type="file"
                  aria-describedby="addon-right addon-left"
                  alternative=""
                  class="form-control form-control-alternative"
                  name="img"
                  @change="hadleimage($event,'add')"
                >
                <base-progress type="success" v-model="uploadPercentage" label="File uploaded"></base-progress>
                <div class="position-relative" v-if="model.user_dp">
                  <base-button
                    type="danger"
                    size="sm"
                    class="position-absolute btn-icon-only"
                    @click="deleteogimage(model)"
                    style="right: 0px;top: -5px;font-size: x-small;width: 1.3rem; height: 1.3rem;"
                    round
                    >
                    <i class="fas fa-times"></i>
                </base-button>
                  <img :src="model.user_dp" style="max-width: 100px" class="img-fluid rounded shadow mt-2 card-body">
                </div>
            </div>
            <div class="col-lg-12">
               <label class="form-control-label">User Gender</label>
                <select v-model="model.user_gender"  aria-describedby="addon-right addon-left" class="form-control" autocomplete="off">
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>

               </select>
            </div>
            <div class="col-lg-12">
              <label class="form-control-label">User Class</label>
              <select class="form-control" v-model="model.user_class" @change="get_classwise_section(1)">
                <option value="">User Class</option>
                <option v-for="classes in classesData" :key="classes._id" :value="classes._id">{{classes.class_name}}</option>
              </select>
              <div
                  v-if="$v.model.user_class.$error"
                  class="error h5 text-danger mt-1 pl-1"
                >
                  Field is required.
              </div>
            </div>
            <div class="col-lg-12">
              <label class="form-control-label">User section</label>
              <select class="form-control" v-model="model.user_section">
                <option value="">User section</option>
                <option v-for="section in sectionData" :key="section._id" :value="section._id">{{section.section_name}}</option>
              </select>
            </div>
            <!-- <div class="col-lg-12">
                <base-input label="Password" placeholder="Password" v-model="model.user_password" input-classes="" />
            </div>
            <div class="col-lg-12">
                <base-input label="Confirm Password" placeholder="Confirm Password" v-model="model.cuser_password" input-classes="" />
            </div> -->
            <div class="col-lg-12">
               <label class="form-control-label">Status</label>
                <select v-model="model.user_status"  aria-describedby="addon-right addon-left" class="form-control" autocomplete="off">
                    <option value="approved">active</option>
                    <option value="disapproved">inactive</option>
               </select>
            </div>
            <div class="col-lg-12">
               <label class="form-control-label">Result</label>
                <select  aria-describedby="addon-right addon-left" class="form-control " autocomplete="off" v-model="model.result_allowed">
                    <option>enable</option>
                    <option>disable</option>
               </select>
            </div>
            <div class="col-lg-12">
               <label class="form-control-label">Tc</label>
                <select  aria-describedby="addon-right addon-left" class="form-control " autocomplete="off" v-model="model.tc_allowed">
                    <option>enable</option>
                    <option>disable</option>
               </select>
            </div>
            <!-- <div class="col-lg-12">
                <span v-if="passworderror" style="color: red">{{passworderror}}</span>
            </div> -->
          </div>
        </form>
      </template>

      <template slot="footer">
        <base-button
          :disabled="$v.model.$error" @click="$v.model.$touch();createstudent()"
          id="createstudentbtn"
          type="success"
          class="float-center"
        >
          <span>Save Student</span>
        </base-button>
        <base-button
          type="link"
          class="ml-auto"
          @click="addstudent = false"
        >
          <span>Close</span>
        </base-button>
      </template>
    </modal>

    <modal :show.sync="editstudent">
      <p
        id="modal-title-default"
        slot="header"
        class="modal-title"
      >
        <span>Edit student</span>
      </p>
      <template>
        <form @submit.prevent>
          <div class="row">
            <div class="col-lg-12">
                <base-input label="User Name" placeholder="User Name" v-model="editmodel.user_name" input-classes="" />
                <div
                  v-if="$v.editmodel.user_name.$error"
                  class="error h5 text-danger mt--4 pl-1"
                >
                  Field is required.
              </div>
            </div>
            <div class="col-lg-12">
                <base-input label="Admission number" placeholder="Admission number" v-model="editmodel.admission_no" input-classes="" />
                 <div
                  v-if="$v.editmodel.admission_no.$error"
                  class="error h5 text-danger mt--4 pl-1">
                  Field is required.
                 </div>
            </div>
            <div class="col-lg-12">
                <base-input label="User Email" placeholder="User Email" v-model="editmodel.user_email" input-classes="" />
                <div
                  v-if="$v.editmodel.user_email.$error"
                  class="error h5 text-danger mt--4 pl-1"
                >
                  Field is required.
                </div>
            </div>
            <div class="col-lg-12">
                <base-input label="User Phone" placeholder="User Phone" v-model="editmodel.user_phone" input-classes="" />
                <div
                  v-if="$v.editmodel.user_phone.$error"
                  class="error h5 text-danger mt--4 pl-1"
                >
                  Field is required.
                </div>
            </div>
            <div class="col-lg-12">
                <base-input type="date" label="DOB" placeholder="DOB" v-model="editmodel.user_dob" input-classes="" />
                <div
                  v-if="$v.editmodel.user_dob.$error"
                  class="error h5 text-danger mt--4 pl-1"
                >
                  Field is required.
                </div>
            </div>
            <div class="col-lg-12">
                <base-input label="Father's Name" placeholder="Father's Name" v-model="editmodel.father_name" input-classes="" />
            </div>
            <div class="col-lg-12">
                <base-input label="Mother's Name" placeholder="Mother's Name" v-model="editmodel.mother_name" input-classes="" />
            </div>
            
            <div class="col-lg-12">
              <label class="form-control-label">Profile Picture</label>
              <input
                  id="file"
                  ref="myFiles"
                  type="file"
                  aria-describedby="addon-right addon-left"
                  alternative=""
                  class="form-control form-control-alternative"
                  name="img"
                  @change="hadleimage($event,'add')"
                >
                <base-progress type="success" v-model="uploadPercentage" label="File uploaded"></base-progress>
                <div class="position-relative" v-if="editmodel.user_dp">
                  <base-button
                    type="danger"
                    size="sm"
                    class="position-absolute btn-icon-only"
                    @click="deleteogimage(editmodel)"
                    style="right: 0px;top: -5px;font-size: x-small;width: 1.3rem; height: 1.3rem;"
                    round
                    >
                    <i class="fas fa-times"></i>
                </base-button>
                  <img :src="editmodel.user_dp" style="max-width: 100px" class="img-fluid rounded shadow mt-2 card-body">
                </div>
            </div>
            <div class="col-lg-12">
               <label class="form-control-label">User Gender</label>
                <select v-model="editmodel.user_gender"  aria-describedby="addon-right addon-left" class="form-control" autocomplete="off">
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
               </select>
            </div>
            <div class="col-lg-12">
              <label class="form-control-label">User Class</label>
              <select class="form-control" v-model="editmodel.user_class" @change="get_classwise_section(2)">
                <option value="">User Class</option>
                <option v-for="classes in classesData" :key="classes._id" :value="classes._id">{{classes.class_name}}</option>
              </select>
              <div
                  v-if="$v.editmodel.user_class.$error"
                  class="error h5 text-danger mt-1 pl-1"
                >
                  Field is required.
              </div>
              <div
                  v-if="$v.model.user_class.$error"
                  class="error h5 text-danger mt-1 pl-1"
                >
                  Field is required.
                </div>
            </div>
            <div class="col-lg-12">
              <label class="form-control-label">User section</label>
              <select class="form-control" v-model="editmodel.user_section">
                <option value="">User section</option>
                <option v-for="section in sectionData" :key="section._id" :value="section._id">{{section.section_name}}</option>
              </select>
            </div>
            <!-- <div class="col-lg-12">
                <base-input label="Password" placeholder="Password" v-model="editmodel.user_password" input-classes="" />
            </div> -->
            <!-- <div class="col-lg-12">
                <base-input label="Confirm Password" placeholder="Confirm Password" v-model="editmodel.cuser_password" input-classes="" />
            </div> -->
            <div class="col-lg-12">
               <label class="form-control-label">Status</label>
                <select v-model="editmodel.user_status"  aria-describedby="addon-right addon-left" class="form-control" autocomplete="off">
                    <option value="approved">active</option>
                    <option value="disapproved">inactive</option>
               </select>
            </div>
            <div class="col-lg-12">
               <label class="form-control-label">Result</label>
                <select  aria-describedby="addon-right addon-left" class="form-control " autocomplete="off" v-model="editmodel.result_allowed">
                    <option>enable</option>
                    <option>disable</option>
               </select>
            </div>
            <div class="col-lg-12">
               <label class="form-control-label">Tc</label>
                <select  aria-describedby="addon-right addon-left" class="form-control " autocomplete="off" v-model="editmodel.tc_allowed">
                    <option>enable</option>
                    <option>disable</option>
               </select>
            </div>
            <!-- <div class="col-lg-12">
                <span v-if="passworderror" style="color: red">{{passworderror}}</span>
            </div> -->
          </div>
        </form>
      </template>

      <template slot="footer">
        <base-button
          :disabled="$v.editmodel.$error" @click="$v.editmodel.$touch();updatestudent()"
          id="updatestudentbtn"
          type="success"
          class="float-center"
        >
          <span>Update Student</span>
        </base-button>
        <base-button
          type="link"
          class="ml-auto"
          @click="editstudent = false"
        >
          <span>close</span>
        </base-button>
      </template>
    </modal>
    </div>
  </div>
</template>
<script>
  // Charts
  import * as chartConfigs from '@/components/Charts/config';
  import LineChart from '@/components/Charts/LineChart';
  import BarChart from '@/components/Charts/BarChart';

  // Components
  import BaseProgress from '@/components/BaseProgress';
  // import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
  import StatsCard from '@/components/Cards/StatsCard';
  import DropzoneFileUpload from '@/components/Inputs/DropzoneFileUpload'
  import moment from 'moment';
  import VueSwal from 'vue-swal';
  import axios from "axios";
  import { required, minLength, between } from 'vuelidate/lib/validators';

  // Lists
  // import ActivityFeed from './ActivityFeed';
  // import TaskList from './TaskList';
  // import UserList from './UserList';
  // import ProgressTrackList from './ProgressTrackList';

  // // Tables
  // import LightTable from './LightTable';
  // import SocialTrafficTable from './SocialTrafficTable';
  // import PageVisitsTable from './PageVisitsTable';

  export default {
    components: {
      // ActivityFeed,
      // LineChart,
      // BarChart,
      // BaseProgress,
      // StatsCard,
      // TaskList,
      // PageVisitsTable,
      // SocialTrafficTable,
      // LightTable,
      // UserList,
      // ProgressTrackList
      DropzoneFileUpload,
    },
    data() {
      return {
        inputs: {
          file: []
        },
        status:'',
        orderData:[],
        userData:[],
        classesData:[],
        sectionData:[],
        datanotfound:false,
        variationData:[],
        pagination_load:false,
        search_term:'',
        order_status:'',
        role:localStorage.getItem('role'),
        totalorder:{count:0,sum:0},
        pendingorder:{count:0,sum:0},
        confirmorder :{count:0,sum:0},
        preparingorder:{count:0,sum:0},
        readyorder:{count:0,sum:0},
        dispatchorder:{count:0,sum:0},
        completeorder:{count:0,sum:0},
        cancelorder:{count:0,sum:0},
        returnorder:{count:0,sum:0},
        subcategoryproductData:[],
        storeData:[],
        galleryarr:[],
        banneruploadPercentage:0,
        offset:0,
        loadmorefound:1,
        addstudent:false,
        editstudent:false,
        model:{
          user_name:'',
          admission_no:'',
          user_dob:'',
          father_name:'',
          mother_name:'',
          result_allowed:'',
          tc_allowed:'',
          user_email:'',
          user_password :'',
          user_dp:'',
          user_status:'approved',
          user_phone:'',
          user_gender:'male',
          user_class :'',
          user_section :'',
          verified :true,
        },
        editmodel:{
          user_id:'',
          user_name:'',
          admission_no:'',
          user_dob:'',
          father_name:'',
          mother_name:'',
          result_allowed:'',
          tc_allowed:'',
          user_email:'',
          user_password :'',
          user_dp:'',
          user_status:'approved',
          user_phone:'',
          user_gender:'male',
          user_class :'',
          user_section :'',
          verified :true,
        },
        editcategory:false,
        ordermodal:{ order_no:'',order_status:''},
        editproduct:false,
        uploadPercentage:0,
        item_price:[{item_id : '',item_name : '',unit : '',quantity : 0,availability_now : 0,marked_price : 0,price : 0,is_featured : false,sequenced_at : 0,status: "approved",visibility : "visible"}],
        
        auth : {
          headers: { 'Content-Type':'application/x-www-form-urlencoded',
          'Authorization':'caption#' + localStorage.getItem('accessToken'),
          '_id':localStorage.getItem('_id')}
        },
        auth1 : { headers: { 'Content-Type':'application/json',
          'Authorization':'caption#' + localStorage.getItem('accessToken'),
          '_id':localStorage.getItem('_id')}
        },
      }
    },
    validations: {
      model: {
        user_name:{
          required
        },
        admission_no:{
          required
        },
        user_dob:{
          required
        },
        user_email:{
          required
        },
        user_phone:{
          required
        },
        user_class:{
          required
        },
        
      },
      editmodel: {
        user_name:{
          required
        },
        admission_no:{
          required
        },
        user_dob:{
          required
        },
        user_email:{
          required
        },
        user_phone:{
          required
        },
        user_class:{
          required
        },
      },

    },
    mounted () {

      // // redirection for different roles
      // if (localStorage.getItem('role') == 'Kitchen') {
      //   document.location.href = "/kitchen";
      // }
      // if (localStorage.getItem('role') == 'SEO Team') {
      //   document.location.href = "/seo/meta";
      // } else {
      //   console.log(localStorage.getItem('role'));
      // }


      // const querystring = require('querystring');
      // let details={ "details" :{"type":"order"},"offset":"0"};
      //   if(localStorage.getItem('store_id')!='undefined' && localStorage.getItem('store_id')!=''){
      //             details.details.store_id=localStorage.getItem('store_id');
      //   }
      // axios
      // .post(process.env.VUE_APP_API_ENDPOINT+'read_order',details,this.auth1)
      // .then(response => {
      //   console.log(response);
      //   if(response.data.details){
      //   this.orderData=response.data.details;
      //   this.datanotfound=false;
      //   }else{
      //       this.orderData=[];
      //       this.datanotfound=true;
      //   }
            
      // })
      
      // axios
      // .post(process.env.VUE_APP_API_ENDPOINT+'read_order_count',details,this.auth1)
      // .then(response => {
      //   console.log(response);
      //   if(response.data.details.length>0){
      //   this.totalorder.count=response.data.details[0].COUNT;
      //   this.totalorder.sum=response.data.details[0].SUM/100;
      //   }
            
      // })
      // details.details.order_status="pending";
      // axios
      // .post(process.env.VUE_APP_API_ENDPOINT+'read_order_count',details,this.auth1)
      // .then(response => {
      //   console.log(response);
      //   if(response.data.details.length>0){
      //   this.pendingorder.count=response.data.details[0].COUNT;
      //   this.pendingorder.sum=response.data.details[0].SUM/100;
      //   }
            
      // })
      // details.details.order_status="confirm";
      // axios
      // .post(process.env.VUE_APP_API_ENDPOINT+'read_order_count',details,this.auth1)
      // .then(response => {
      //   console.log(response);
      //   if(response.data.details.length>0){
      //   this.confirmorder.count=response.data.details[0].COUNT;
      //   this.confirmorder.sum=response.data.details[0].SUM/100;
      //   }
            
      // })
      // details.details.order_status="preparing";
      // axios
      // .post(process.env.VUE_APP_API_ENDPOINT+'read_order_count',details,this.auth1)
      // .then(response => {
      //   console.log(response);
      //   if(response.data.details.length>0){
      //   this.preparingorder.count=response.data.details[0].COUNT;
      //   this.preparingorder.sum=response.data.details[0].SUM/100;
      //   }
            
      // })
      // details.details.order_status="ready";
      // axios
      // .post(process.env.VUE_APP_API_ENDPOINT+'read_order_count',details,this.auth1)
      // .then(response => {
      //   console.log(response);
      //   if(response.data.details.length>0){
      //   this.readyorder.count=response.data.details[0].COUNT;
      //   this.readyorder.sum=response.data.details[0].SUM/100;
      //   }
            
      // })
      // details.details.order_status="dispatch";
      // axios
      // .post(process.env.VUE_APP_API_ENDPOINT+'read_order_count',details,this.auth1)
      // .then(response => {
      //   console.log(response);
      //   if(response.data.details.length>0){
      //   this.dispatchorder.count=response.data.details[0].COUNT;
      //   this.dispatchorder.sum=response.data.details[0].SUM/100;
      //   }
            
      // })
      // details.details.order_status="delivered";

      // axios
      // .post(process.env.VUE_APP_API_ENDPOINT+'read_order_count',details,this.auth1)
      // .then(response => {
      //   console.log(response);
      //   if(response.data.details.length>0){
      //   this.completeorder.count=response.data.details[0].COUNT;
      //   this.completeorder.sum=response.data.details[0].SUM/100;
      //   }
            
      // })
      // details.details.order_status="cancelled";

      // axios
      // .post(process.env.VUE_APP_API_ENDPOINT+'read_order_count',details,this.auth1)
      // .then(response => {
      //   console.log(response);
      //   if(response.data.details.length>0){
      //   this.cancelorder.count=response.data.details[0].COUNT;
      //   this.cancelorder.sum=response.data.details[0].SUM/100;
      //   }
            
      // })
      // details.details.order_status="returned";
      // axios
      // .post(process.env.VUE_APP_API_ENDPOINT+'read_order_count',details,this.auth1)
      // .then(response => {
      //   console.log(response);
      //   if(response.data.details.length>0){
      //   this.returnorder.count=response.data.details[0].COUNT;
      //   this.returnorder.sum=response.data.details[0].SUM/100;
      //   }
            
      // })
      

      // axios
      // .post(process.env.VUE_APP_API_ENDPOINT+'read_store',{ "details" :{}},this.auth1)
      // .then(response => {
      //   console.log(response);
      //   if(response.data.details){
      //   this.storeData=response.data.details;
      //   }
            
      // })

      axios
      .post(process.env.VUE_APP_API_ENDPOINT+'read_class',{ "details" :{},"offset":"0"},this.auth1)
      .then(response => {
        console.log(response);
        if(response.data.details){
         this.classesData=response.data.details;
        }
            
      })

      axios
      .post(process.env.VUE_APP_API_ENDPOINT+'read_student',{ "details" :{"user_type":'student'},"offset":"0"},this.auth1)
      .then(response => {
        console.log(response);
        if(response.data.details){
          this.datanotfound=false;
        this.userData=response.data.details;
        
        }else{
            this.userData=[]; 
            this.datanotfound=true;
        }
            
      })


    },
    methods: {
          getalldata(){
              let details={ "details" :{"type":"order"},"offset":this.offset};
              if(localStorage.getItem('store_id')!='undefined' && localStorage.getItem('store_id')!=''){
                        details.details.store_id=localStorage.getItem('store_id');
              }
              axios
                .post(process.env.VUE_APP_API_ENDPOINT+'read_order',details,this.auth1)
                .then(response => {
                  console.log(response);
                  if(response.data.details){
                  this.orderData=response.data.details;
                  this.datanotfound=false;
                  }else{
                      this.datanotfound=true;
                      this.orderData=[];
                  }
                      
                })

          },
          openuser(row){
          console.log(row);
          this.editstudent=true;
          this.editmodel =row;
          if(row.user_dob){
          let date=row.user_dob.split('T');
          this.editmodel.user_dob=date[0];
          }
          if(row.user_class){
          this.editmodel.user_class=row.user_class._id;
          }
        },
        cleardata(){

           axios
            .post(process.env.VUE_APP_API_ENDPOINT+'read_student',{ "details" :{"user_type":'student'},"offset":"0"},this.auth1)
            .then(response => {
              console.log(response);
              if(response.data.details){
                this.datanotfound=false;
                this.userData=response.data.details;
              
              }else{
                  this.userData=[]; 
                  this.datanotfound=true;
              }
                  
            })

        },
        addstudentpop(){
          this.addstudent=true;
        },
        hadleimage: function(event,type) {
            // Reference to the DOM input element
            this.uploadPercentage =0;
            var input = event.target;
            // Ensure that you have a file before attempting to read it
            if(input.files[0].size < 5000000){

            const fd= new FormData();
            fd.append('image',input.files[0],input.files[0].name);
            axios
            .post(process.env.VUE_APP_API_ENDPOINT+'image-upload',fd,{ headers: {'Content-Type': 'multipart/form-data'},onUploadProgress: function( progressEvent ) { this.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded * 100 ) / progressEvent.total ) ); console.log(this.uploadPercentage)}.bind(this)})
            .then(response => {
              console.log(response);
              if(type=='add'){
                this.model.user_dp=response.data.imageUrl;
                console.log(this.model.user_dp);
              } else if(type=='edit'){
                this.editmodel.user_dp=response.data.imageUrl;
                console.log(this.editmodel.user_dp);
              }
                
            })

            }else{

            swal({
              title:'File too large!',
              text: 'Your file is larger than 5 MB. Please upload images which are less than 5 MB.',
              icon:'warning',
              }).then((result) => {
               
              })
            }
      },
       loadmore(){
          this.offset=this.offset+1;
          const querystring = require('querystring');
          console.log(this.auth);
          axios
          .post(process.env.VUE_APP_API_ENDPOINT+'get_user_details',{ "details" :{},"offset":this.offset.toString()},this.auth1)
          .then(response => {
            console.log(response);
            if(response.data.details){
            //this.orderData=response.data.details;
             for (var i = 0; i < response.data.details.length; i++) {
                    this.userData.push(response.data.details[i]);
                }
            // this.productData.push(response.data.details);
                if(response.data.details.length < 30){
                   this.loadmorefound=0; 
                }
            }else{
                this.loadmorefound=0;

            } 
                
          })
        },
        searchuser(){
        axios
        .post(process.env.VUE_APP_API_ENDPOINT+'search_user',{ "search_term" :this.search_term},this.auth1)
        .then(response => {
          console.log(response);
          if(response.data.details){
          this.datanotfound=false;
          this.userData=response.data.details;
          }else{
            this.datanotfound=true;
            this.userData=[];
          }
              
         })
        },
        createstudent(){
           const querystring = require('querystring');
           if(this.$v.model.$error===false){
           // if(this.model.user_password==this.model.cuser_password){
           axios.post(process.env.VUE_APP_API_ENDPOINT+'create_student',querystring.stringify({user_name : this.model.user_name,user_phone : this.model.user_phone,user_email : this.model.user_email,admission_no : this.model.admission_no,user_gender : this.model.user_gender,user_class : this.model.user_class,user_dp : this.model.user_dp,user_dob : this.model.user_dob,father_name : this.model.father_name,mother_name : this.model.mother_name,result_allowed : this.model.result_allowed,tc_allowed : this.model.tc_allowed,user_status : this.model.user_status,user_section:this.model.user_section}),this.auth)
          .then(response => {
            console.log(response);
            this.message=response.data.message;
            document.getElementById("createstudentbtn").classList.remove('btn-primary');
            document.getElementById("createstudentbtn").classList.add('btn-success');
            document.getElementById("createstudentbtn").innerHTML='Updated';
            setTimeout(function(){
            document.getElementById("createstudentbtn").classList.remove('btn-success');
            document.getElementById("createstudentbtn").classList.add('btn-primary');
            document.getElementById("createstudentbtn").innerHTML="Update";
            window.location.reload()
          }, 2000);

          })
        }
        // }else{
        //   this.passworderror="Confirm Password not match";
        // }
      },
      updatestudent(){
        const querystring = require('querystring');
        if(this.$v.editmodel.$error===false){
        axios.post(process.env.VUE_APP_API_ENDPOINT+'update_student',querystring.stringify({user_id:this.editmodel.user_id,user_name : this.editmodel.user_name,user_phone : this.editmodel.user_phone,user_email : this.editmodel.user_email,admission_no : this.editmodel.admission_no,user_gender : this.editmodel.user_gender,user_class : this.editmodel.user_class,user_dp : this.editmodel.user_dp,user_dob : this.editmodel.user_dob,father_name : this.editmodel.father_name,mother_name : this.editmodel.mother_name,result_allowed : this.editmodel.result_allowed,tc_allowed : this.editmodel.tc_allowed,user_status : this.editmodel.user_status,user_section:this.editmodel.user_section}),this.auth)
        .then(response => {
          console.log(response);
          this.message=response.data.message;
          document.getElementById("updatestudentbtn").classList.remove('btn-primary');
          document.getElementById("updatestudentbtn").classList.add('btn-success');
          document.getElementById("updatestudentbtn").innerHTML='Updated';
          setTimeout(function(){
          document.getElementById("updatestudentbtn").classList.remove('btn-success');
          document.getElementById("updatestudentbtn").classList.add('btn-primary');
          document.getElementById("updatestudentbtn").innerHTML="Update";
          window.location.reload()
        }, 2000);
        })
       }
       // }else{
       //    this.passworderror="Confirm Password not match";
       // }
      },
      deletestudent(row) {
        console.log(row);
        const querystring = require('querystring');
          swal({
              title: 'Are you sure?',
              text: "wan't to delete",
              icon: 'warning',
              buttons: {cancel: true,confirm: true}
          }).then((result) => { // <--
            if (result) {
              console.log('result cloud',result)
              axios.post(process.env.VUE_APP_API_ENDPOINT+'delete_student',querystring.stringify({user_id :row.user_id}),this.auth)
            .then(response => {
              console.log(response);
              swal({
                title:'Deleted!',
                text: 'Your file has been deleted.',
                icon:'success',
               }).then((result) => {
                console.log(result)
                window.location.reload()
              })
              })
             }
          });
      },
      getorderbystatus(){
            let details={ "details" :{"type":"order"},"offset":"0"};
              if(localStorage.getItem('store_id')!='undefined' && localStorage.getItem('store_id')!=''){
                        details.details.store_id=localStorage.getItem('store_id');
              }
       if(this.status) {
        details.details.order_status=this.status;
         axios
        .post(process.env.VUE_APP_API_ENDPOINT+'read_order',details,this.auth1)
        .then(response => {
          console.log(response);
          if(response.data.details){
          this.orderData=response.data.details;
           this.datanotfound=false;
          }else{
              this.orderData=[];
              this.datanotfound=true;
          }
              
        })
      }else{

        axios
        .post(process.env.VUE_APP_API_ENDPOINT+'read_order',details,this.auth1)
        .then(response => {
          console.log(response);
          if(response.data.details){
          this.orderData=response.data.details;
          this.datanotfound=false;
          }else{
              this.datanotfound=true;
              this.orderData=[];
          }
              
        })

      }

    },
    searchOrder(){
      let details={ "search_term" :this.search_term};
              if(localStorage.getItem('store_id')!='undefined' && localStorage.getItem('store_id')!=''){
                        details.store_id=localStorage.getItem('store_id');
              }
      axios
      .post(process.env.VUE_APP_API_ENDPOINT+'search_order',{ "search_term" :this.search_term},this.auth1)
      .then(response => {
        console.log(response);
        if(response.data.details){
        this.orderData=response.data.details;
        this.datanotfound=false;
        }else{
          this.orderData=[];
          this.datanotfound=true;
        }
            
       })
      },
      get_classwise_section(type){
        console.log(type);
        let details={ "details" :{},"offset":"0"};
        if(type==1){
          details.details.class_oid=this.model.user_class;
          console.log(this.model.user_class);
        }
        if(type==2){
          details.details.class_oid=this.editmodel.user_class;
          console.log(this.editmodel.user_class);
        }
        axios
        .post(process.env.VUE_APP_API_ENDPOINT+'read_section',details,this.auth1)
        .then(response => {
          console.log(response);
          if(response.data.details){
           this.sectionData=response.data.details;
          }else{
            this.sectionData=[];
          }
              
        })
      },
      // cleardata(){
      //   this.search_term='';
      //   this.status='';
      //   let details={ "details" :{"type":"order"},"offset":"0"};
      //         if(localStorage.getItem('store_id')!='undefined' && localStorage.getItem('store_id')!=''){
      //                   details.details.store_id=localStorage.getItem('store_id');
      //         }
      //    axios
      //      .post(process.env.VUE_APP_API_ENDPOINT+'read_order',details,this.auth1).then(response => {
      //       console.log(response);
      //       if(response.data.details){
      //       this.orderData=response.data.details;
      //       this.datanotfound=false;
      //       }else{
      //         this.orderData=[];
      //         this.datanotfound=true;
      //       }
            
      //  })
          
      // },
      updateorder() {
        console.log(this.ordermodal);
           const querystring = require('querystring');

          axios
          .post(process.env.VUE_APP_API_ENDPOINT+'invoicePdf',querystring.stringify({ order_id: this.ordermodal.order_id,created_by: localStorage.getItem('_id')}),this.auth)
          .then(response => {
            let invoice_url=response.data.details.path;
            axios.post(process.env.VUE_APP_API_ENDPOINT+'update_order',querystring.stringify({ order_id : this.ordermodal.order_id,order_status:this.order_status,"store_id":localStorage.getItem('store_id'),"invoice_url":invoice_url}),this.auth)
            .then(response => {
              console.log(response);
              axios
              .post(process.env.VUE_APP_API_ENDPOINT+'read_order_details',{ "details" :{order_oid:this.ordermodal._id}},this.auth1)
              .then(response => {
                console.log(response);
                if(response.data.details){
                this.ordermodal.order_items=response.data.details;

              let title='';
              let img='';
              let datetime= new Date();
              datetime=datetime.toString();
              let msg_heading='';
              let msg_text='';
              let order_status=this.order_status;
              let name=this.ordermodal.user_oid.user_name;
              let user_phone=this.ordermodal.user_oid.user_phone;
              let order_no=this.ordermodal.order_no;
              let address=this.ordermodal.address;
              let locality=this.ordermodal.locality;
              let city=this.ordermodal.city;
              let pincode=this.ordermodal.pincode;
              let state=this.ordermodal.state;  
              let payment_mode=this.ordermodal.payment_mode;
              let orderdetails=this.ordermodal.order_items;
              let amount=this.ordermodal.amount/100;
              if(this.order_status=='preparing'){
                   img="https://bakenetoweb.s3.ap-south-1.amazonaws.com/products//1622464589278Notification%20Images%20El%20Fresh%20%281%29.png";
                  msg_heading='Your order is successfully placed.';
                  msg_text='We are pleased to confirm your order no #'+order_no+'  <br /> Thank you for shopping with Bakeneto!';
              }
              // if(this.order_status=='ready'){
              //     img="https://bakenetoweb.s3.ap-south-1.amazonaws.com/products//1622464589278Notification%20Images%20El%20Fresh%20%281%29.png";
              //     msg_heading='Your order has been successfully dispatched.';
              //     msg_text='We are pleased to confirm your order no #'+order_no+'  <br /> Thank you for shopping with Bakeneto!';
              // }
              if(this.order_status=='dispatched'){
                  img="https://bakenetoweb.s3.ap-south-1.amazonaws.com/products//1622464042341161945402806316143644133501.png";
                  msg_heading='Your order has been successfully dispatched.';
                  msg_text='We are pleased to confirm your order no #'+order_no+'  <br /> Thank you for shopping with Bakeneto!';
              }
              if(this.order_status=='delivered'){
                  img="https://bakenetoweb.s3.ap-south-1.amazonaws.com/products//1622463884633161945406485116143645588443.png";
                  msg_heading='Your order is successfully delivered.';
                  msg_text='We are pleased to deliver your order no #'+order_no+'  <br /> Thank you for shopping with Bakeneto!';
              }
              if(this.order_status=='cancelled'){
                  img="https://bakenetoweb.s3.ap-south-1.amazonaws.com/products//1622464265544161945411566116143646488074%20%281%29%20%281%29.png";
                  msg_heading='Your order is cancelled.';
                  msg_text='Your order (#'+order_no+') has been cancelled upon your request. Your refund amount will be deposited in your bank account within 4-5 working days. <br /> Thank you for shopping with Bakeneto!';
              }
              //mail template
              let message='<div style="width: 100%; height: 100%; margin: 10px auto; padding: 0; background-color: #f1f2f3; font-family: Roboto-Regular, Arial, Tahoma, Verdana, sans-serif; font-weight: 300; font-size: 13px; text-align: center;"> <div style="background: #ffffff;max-width: 680px;padding-top: 15px;margin: 0 auto;height: 45px;border-bottom: 5px solid #ef613e;border-radius: 0 0 5px 5px;"> <div style="width: 45%; text-align: left; float: left; padding-left: 16px;"> <a style="text-decoration: none; outline: none; color: #ffffff; font-size: 13px;" href="#" target="_blank" > <img border="0" height="30" src="https://bakeneto.com/img/brand/red.png" alt="Bakeneto.com" style="border: none;height:30px;" /> </a> </div> <div style="text-align: right; margin-top: 6px; font-family: Roboto-Medium, sans-serif; font-size: 14px; font-style: normal; font-stretch: normal; padding-right: 16px;width:50%;float:right;"> Order '+order_status+' </div> </div> <table width="100%" cellspacing="0" cellpadding="0" style="margin: 0 auto; padding: 10px; background-color: #f1f2f3;"> <tbody> <tr> <td> <table width="100%" cellspacing="0" cellpadding="0" style="margin: 0 auto;max-width: 600px;background: #ffffff;border-top: 5px solid #d6d6d6;border-radius: 5px 5px 0 0;"> <tbody> <tr> <td align="left" valign="top" style="display: block; margin: 0 auto; clear: both; padding: 0px 40px;"> <table width="100%" cellspacing="0" cellpadding="0" style="margin: 0 auto; padding: 30px 0 0 0; max-width: 600px; background: #ffffff;" border="0"> <tbody> <tr> <td> <table width="100%" border="0" cellpadding="0" cellspacing="0" align="left" style="table-layout: fixed; border-spacing: 0; border-collapse: collapse; width: 100%; max-width: 260px; border: none; margin-bottom: 24px; margin-right: 30px;" > <tbody> <tr> <td valign="top" align="left" style="border-right: 1px solid #f4f4f4; padding-right: 10px;"> <p style="padding: 0; margin: 0; font-size: 16px; font-family: Roboto-Medium, sans-serif; color: #212121;margin-bottom: 5px;">Dear '+name+',</p> <p style="padding: 0; margin: 0; font-size: 16px; font-family: Roboto-Medium, sans-serif; color: #212121;">'+msg_heading+'</p> <p style="padding: 0; margin: 0; font-size: 16px; font-family: Roboto-Medium, sans-serif; color: #212121; margin-bottom: 12px;"></p> <p style="padding: 0; margin: 0; font-size: 12px; line-height: 20px; font-family: Roboto, sans-serif; font-weight: 400; padding-bottom: 12px;">'+msg_text+'</p> </td> </tr> </tbody> </table> <table width="100%" border="0" cellpadding="0" cellspacing="0" align="left" style="border-spacing: 0; border-collapse: collapse; width: 100%; max-width: 220px; border: none; margin-bottom: 24px;" > <tbody> <tr> <td valign="top" align="left"> <p style="padding: 0; margin: 0; font-size: 16px; font-family: Roboto-Medium, sans-serif; color: #212121; margin-bottom: 12px;">Delivery Address</p> <p style="padding: 0; margin: 0; font-size: 12px; font-family: Roboto, sans-serif; line-height: 20px; padding-right: 35px; color: #212121;"></p> <p style="padding: 0; margin: 0; font-size: 12px; font-family: Roboto, sans-serif; line-height: 20px;">'+name+'</p> <p style="padding: 0; margin: 0; font-size: 12px; font-family: Roboto, sans-serif; line-height: 20px;">'+locality+', '+address+'</p><p style="padding: 0; margin: 0; font-size: 12px; font-family: Roboto, sans-serif; line-height: 20px;">'+city+' - '+pincode+'</p> <p style="padding: 0; margin: 0; font-size: 12px; font-family: Roboto, sans-serif; line-height: 20px;">'+state+'</p> <p style="padding: 0; margin: 0; font-size: 12px; font-family: Roboto, sans-serif; line-height: 20px;">Mob. '+user_phone+'</p> <p></p> </td> </tr> </tbody> </table> <table width="600" border="0" cellpadding="0" cellspacing="0" align="left"> <tbody> <tr> <td valign="top" align="left"> <p style=" font-family: Arial; font-size: 12px; text-align: left; color: #212121; padding-top: 0px; padding-bottom: 0px; line-height: 19px; margin-top: 0; margin-bottom: 0; " > <strong style="display:block;width:100%;">Ordered Products</strong></p> </td> </tr> </tbody> </table> </td> </tr> </tbody> </table> <table style="width: 100%; max-width: 600px; border-bottom: 1px solid #f0f0f0; background: #ffffff;" border="0"> <tbody> <tr></tr> </tbody> </table> <table width="100%" cellspacing="0" cellpadding="0" style="margin: 0 auto; max-width: 600px; background: #ffffff;"> <tbody> <tr> <td align="left" valign="top" style="color: #212121; display: block; margin: 0 auto; clear: both; padding: 30px 0 24px 0;"> <table width="100%" cellspacing="0" cellpadding="0"> <tbody>';
                for (let i = 0; i < orderdetails.length; i++) {  
                message+='<tr> <td width="120" valign="top" align="left" style=" padding-bottom: 10px; "> <a style="text-decoration: none;outline: none;color: #ffffff;font-size: 13px;display: block;width: 80px;max-height: 80px;overflow: hidden;border-radius: 5px;" href="https://bakeneto.com/product-page/'+orderdetails[i].products.item_id+'" target="_blank" > <img border="0" src="'+orderdetails[i].products.item_thumbnail+'" alt="'+orderdetails[i].products.item_name+'" style="border: none; margin-left: 0px; margin-right: auto; display: block; width: fit-content;max-width: 80px;border-radius: 5px;" class="CToWUd" /> </a> </td> <td valign="top" align="left" width="320"> <p style="margin-bottom: 13px;"> <a href="https://bakeneto.com/product-page/'+orderdetails[i].products.item_id+'" style=" font-family: Roboto, sans-serif; font-size: 14px; font-weight: normal; font-style: normal; font-stretch: normal; line-height: 1.25; color: #2175ff; text-decoration: none; " target="_blank" >'+orderdetails[i].products.item_name+' </a> <sup></sup> <br /> </p><p style=" font-family: Roboto, sans-serif; font-size: 12px; font-weight: normal; font-style: normal; line-height: 1.5; font-stretch: normal; color: #212121; margin: 0px 0px; " > '+orderdetails[i].item_price_type.quantity+' '+orderdetails[i].item_price_type.unit+' </p> <p style="font-family: Roboto-Medium, sans-serif; font-style: normal; line-height: 1.5; font-stretch: normal; color: #212121; margin: 5px 0px;"> <span style="padding-right: 10px;">₹'+orderdetails[i].item_price_type.price+'</span> <span style=" font-family: Roboto-Medium, sans-serif; font-size: 12px; font-weight: normal; font-style: normal; line-height: 1.5; font-stretch: normal; color: #878787; margin: 0px 0px; border: 1px solid #dfdfdf; display: inline; border-radius: 3px; padding: 3px 10px; " > Qty: '+orderdetails[i].product_qty+' </span> </p> </td> <td valign="top"> <a href="https://bakeneto.com/product-page/'+orderdetails[i].products.item_id+'#rating" style="padding: 7px 10px;background-color: #ef613e;color: white;text-decoration: none;border-radius: 5px;font-family: sans-serif;font-size: .8rem;margin-top: 10px;display: block;text-align: center;width: 75%;margin-left: auto;">Rate the product</a> </td> </tr>';
                  }
                message+='</tbody> </table> </td> </tr> </tbody> </table> <table width="100%" border="0" cellpadding="0" cellspacing="0"> <tbody> <tr> <td height="1" style="background-color: #f0f0f0; font-size: 0px; line-height: 0px;" bgcolor="#f0f0f0"></td> </tr> </tbody> </table> <table width="100%" border="0" cellpadding="0" cellspacing="0"> <tbody> <tr> <td height="1" style="background-color: #f0f0f0; font-size: 0px; line-height: 0px;" bgcolor="#f0f0f0"></td> </tr> </tbody> </table> <table width="100%" cellspacing="0" cellpadding="0" style="margin: 0 auto; padding: 30px 0 0 0; max-width: 600px; background: #ffffff;" border="0"> <tbody> <tr> <td> <table width="100%" border="0" cellpadding="0" cellspacing="0" align="left" style="border-spacing: 0; border-collapse: collapse; width: 100%; max-width: 220px; border: none; margin-bottom: 24px;"> <tbody> <tr> <td valign="top" align="left"> <p style="padding: 0; margin: 0; font-size: 14px; font-family: Roboto-Medium, sans-serif; color: #212121; margin-bottom: 12px;">Payment Details</p> <table width="100%" border="0" cellpadding="0" cellspacing="0"> <tbody> <tr> <td style="padding: 0px;"> <p style="padding: 0; margin: 0; font-size: 12px; font-family: Roboto, sans-serif; font-weight: 400; color: #212121;"> Amount Payable on Delivery <span style="padding: 0; margin: 0; font-size: 12px; font-family: Roboto-Medium, sans-serif; color: #212121; padding-left: 10px;">₹'+amount+'</span> </p> </td> </tr> </tbody> </table> </td> </tr> </tbody> </table> </td> <td style="text-align: center;"> <a href="'+invoice_url+'" style=" padding: 15px; background-color: #54b854; color: white; text-decoration: none; border-radius: 5px; font-family: sans-serif; ">Download Invoice</a> </td> </tr> <tr> <td style="padding: 0px;"> <p style="padding: 0; margin: 0; font-size: 12px; font-family: Roboto, sans-serif; font-weight: 400; color: #212121;"> Payment mode :<span style="padding: 0; margin: 0; font-size: 12px; font-family: Roboto-Medium, sans-serif; color: #212121; padding-left: 10px;">'+payment_mode+'</span> </p> </td> </tr> </tbody> </table> <br /> </td> </tr> </tbody> </table> <table width="100%" border="0" cellpadding="0" cellspacing="0"> <tbody> <tr> <td height="1" style="background-color: #f0f0f0; font-size: 0px; line-height: 0px;" bgcolor="#f0f0f0"></td> </tr> </tbody> </table> </td> </tr> </tbody> </table> <table width="100%" cellspacing="0" cellpadding="0" style="margin: 0 auto; max-width: 600px; margin-top: 10px;margin-bottom: 10px;"> <tbody> <tr> <td align="left" valign="top" style="color: #2c2c2c; display: block; line-height: 20px; font-weight: 300; margin: 0 auto; clear: both; background-color: transparent;"> <table style="text-align: center;margin: auto;"> <tbody> <tr> <td style="width: 100%; text-align: center;"> <a style="color: #027cd8; text-decoration: none; outline: none; color: #ffffff; font-size: 13px;" href="#" target="_blank" > <img border="0" height="50" src="https://bakeneto.com/img/brand/red.png" alt="Bakeneto.com" style="border: none;height:50px;" class="CToWUd" /> </a> </td> </tr> <tr> <td style="width: 100%; text-align: center;"> <a style="color: #ef613e; text-decoration: none; outline: none; font-size: 13px;" href="https://bakeneto.com" target="_blank"> Bakeneto.com </a> </td> </tr> </tbody> </table> </td> </tr> </tbody> </table> <img style="width: 1px; height: 1px;" src="https://ci5.googleusercontent.com/proxy/of2aZ7knL5CxEa8F8aZ46X08Ng9atQwmyw1vsqbopYypXklKaz-rQnALOE9fy0bP3GYh1nygy9zPHpIHAZYdsbAle2ql9EyZfx6yMA4IltKvDStbNs0P6B7YFcAsEGjoLZb3Yl7Js4v-HW4bUkBRvFBktvO-Q9CKdmzv_AoPGYfxPaRnXn405GX1gMVhNxg7_OubIWrdkr0Ct7OjbR8vcpnkk9spzA_ULIk7OOuYvNov7Jp9XHwLsHqM7BYcUD4HADPCAfPHxPqDj1oYZG4IOl2sR6yrsY9PihpwZzDe3jhQ-mIVlp5awBwLi_KO99hOt0imjghl9QNL=s0-d-e1-ft#http://l.flipkart.com/t/open/H4sIAAAAAAAAAB2MzQ7CIBCE32XPpWEV-enJi0efwSwULLFNGwKmxvjurt5m5vsyb3jCgB0EGCAulGfoIHPW-mjiwaFwyqBQzgVhk5LCS-nRhpNPLrI6srpQKy_qC01tRsTz_XfTh3VhHioLJVKY1lb_fefhchW17DeyRkqdDLkxeobEKM15e1Cp8PkCqJhVxpoAAAA=" class="CToWUd" /> <div class="yj6qo"></div> <div class="adL"></div> </div>';
                if(img){
                axios.post(process.env.VUE_APP_API_ENDPOINT+'create_notification',querystring.stringify({user_oid:this.ordermodal.user_oid._id,notif_todo : 'openOrderDetails',notif_title:'You order has been '+this.order_status,notif_message:'View order details',notif_img:img,notif_link:this.ordermodal._id,created_by:localStorage.getItem('_id'),notif_date:datetime}),this.auth)
                .then(response => {
            
                  // console.log(response);
                  axios
                  .post(process.env.VUE_APP_API_ENDPOINT+'push_notification',querystring.stringify({ fcm_token:this.ordermodal.user_oid.user_fcm,notif_todo:'openOrderDetails',notif_title:'You order has been '+this.order_status,notif_message:'View order details',notif_img:img,notif_thumbnail:img,notif_link:this.ordermodal._id,sender_id:'Admin',notification_id:response.data.details.notification_id}),this.auth)
                  .then(response => {
                    // console.log(response); 
                  })
                })
              }
           
              if(this.order_status=='delivered'){
                let smsmessage = "Dear "+this.ordermodal.user_oid.user_name+", Thank you for ordering with Bakeneto. Click here to share feedback. https://bakeneto.com/product-page/"+orderdetails[0].products.item_id+"#rating";
                let senderid= "BKNETO";
                let user_phone=this.ordermodal.user_oid.user_phone;
                let sms_url="https://api.textlocal.in/send/?apikey=YTcwYWMyODBjZjE0NTdlNmJmOTY4NTU4MDMxYmFmNjM=&numbers="+encodeURIComponent(user_phone)+"&sender="+senderid+"&message="+encodeURIComponent(smsmessage);
                console.log(sms_url);
                  console.log(sms_url);
                  axios.get(sms_url).then(response => {
                    console.log("Successfully sent with response: ", response); 
                 })
                axios
                .post(process.env.VUE_APP_API_ENDPOINT+'send_mail',querystring.stringify({ email:this.ordermodal.user_oid.user_email,user_name:this.ordermodal.user_oid.user_name,subject_body:'You order has been successfully delivered',type:'orderupdate',html_body:message}),this.auth)
                  .then(response => {
                    console.log(response);
                  })
                  console.log(this.ordermodal);
                  if(this.ordermodal.user_oid.redemption_done=='no' && this.ordermodal.user_oid.refer_by_code!=undefined){
                    axios
                    .post(process.env.VUE_APP_API_ENDPOINT+'read_rewardpoint',{ "details" :{}},this.auth1)
                    .then(response => {
                        console.log(response);
                        if(response.data.details){
                        let rewarddata=response.data.details[0];
                        axios
                          .post(process.env.VUE_APP_API_ENDPOINT+'credit_user_rewardpoint',querystring.stringify({ order_oid:this.ordermodal._id,credit:rewarddata.referral_point,r_credit:rewarddata.referee_point}),this.auth)
                          .then(response => {
                            
                          })
                      }
                    })
                }
              }
              let _this=this;
              document.getElementById("updateproductbtn").innerHTML='...';
              document.getElementById("updateproductbtn").classList.remove('btn-primary');
              document.getElementById("updateproductbtn").classList.add('btn-success');
              document.getElementById("updateproductbtn").innerHTML='You order has been '+_this.order_status;
              setTimeout(function(){
                document.getElementById("updateproductbtn").classList.remove('btn-success');
                document.getElementById("updateproductbtn").classList.add('btn-primary');
                document.getElementById("updateproductbtn").innerHTML="Update";
                _this.editcategory=false;
                _this.getalldata();
               }, 2000);
                window.location.reload()
              }       
            })
          })
        })
      },
      deleteorder(row) {
        console.log(row);
        const querystring = require('querystring');
          swal({
              title: 'Are you sure?',
              text: "wan't to delete",
              icon: 'warning',
              buttons: {cancel: true,confirm: true,}
          }).then((result) => { // <--
            if (result) {
              console.log('result cloud',result)
              axios.post(process.env.VUE_APP_API_ENDPOINT+'delete_order',querystring.stringify({order_id :row.order_id,order_oid:row._id}),this.auth)
            .then(response => {
                let _this=this;
                console.log(response);
                swal({
                  title:'Deleted!',
                  text: 'Your order has been deleted.',
                  icon:'success',
                 }).then((result) => {
                  console.log(result)
                  _this.getalldata();
                })
              })
             }
          });
      },
      format_datetime(value){
        if(value) {
          return moment(new Date(value)).format("MMM Do YYYY,[\n] h:mm a")
        }
      },
      format_datetime_utc(value){
        if(value) {
          return moment.utc(new Date(value)).format("MMM Do YYYY,[\n] h:mm a")
        }
      },
      previouspage(){
      const querystring = require('querystring');
      //console.log(this.auth);
      if(this.offset>0){
      --this.offset;
      let details={ "details" :{"user_type":'student'},"offset":this.offset.toString()};
      axios
        .post(process.env.VUE_APP_API_ENDPOINT+'read_student',details,this.auth1)
        .then(response => {
          //console.log(response);
          if(response.data.details){
          this.datanotfound=false;
          this.orderData=response.data.details;
          }else{
            this.orderData=[];
            this.datanotfound=true;
          }
              
        })
    }
    },
    gotopage(){
      const querystring = require('querystring');
      //console.log(this.auth);
      if(document.getElementById("page_no").value){
      this.offset=document.getElementById("page_no").value;
      let details={ "details" :{"type":"order"},"offset":this.offset.toString()};
        if(localStorage.getItem('store_id')!='undefined' && localStorage.getItem('store_id')!=''){
                  details.details.store_id=localStorage.getItem('store_id');
        }
     axios
      .post(process.env.VUE_APP_API_ENDPOINT+'read_order',details,this.auth1)
      .then(response => {
        //console.log(response);
        if(response.data.details){
        this.userData=response.data.details;
        this.datanotfound=false;
        }else{
          this.userData=[];
          this.datanotfound=true;
        }
            
      })

      }

    },
    nextpage(){
        this.offset=this.offset+1;
        const querystring = require('querystring');
        //console.log(this.auth);
        let details={ "details" :{"user_type":'student'},"offset":this.offset.toString()};
        axios
          .post(process.env.VUE_APP_API_ENDPOINT+'read_student',details,this.auth1)
          .then(response => {
            //console.log(response);
            if(response.data.details){
            this.userData=response.data.details;
            this.datanotfound=false;
            }else{
              this.offset=this.offset-1;
              this.userData=[];
              this.datanotfound=true;
            }
                
          })

    },

    },
  };
</script>
<style>
.search-input .form-group {
  display: inline-block;
  margin-bottom: 0px;
}
.homepage .card-stats .icon.icon-shape {
  width: 2.2rem;
  height: 2.2rem;
}
.homepage .card-stats  .icon-shape i, .icon-shape svg {
  font-size: 1rem;
}
</style>
